import { Table } from "antd";
import React, {useState,useEffect} from "react";
import { Link } from "react-router-dom";

import Select from "react-select";
import LeaveTable from "components/Tables/Leaves"

export const EmployeeLeave = ({userData}) => {
   
  return (
    <>
   

        {/* /Assests Tab */}
        <div className="tab-pane fade" id="emp_leaves">
            <LeaveTable userData={userData}/>
        </div>
        {/* /Bank Tab */}

      
    </>
  );
};
